import Vue from 'vue'

Event = new class {
    constructor() {
        this.vue = new Vue();
    }

    fire(event, data = null) {
        this.vue.$emit(event, data);
    }

    listen(event, callback) {
        this.vue.$on(event, callback);
    }

    removeListeners(event) {
        this.vue.$off(event);
    }
}

export default Event
